import React, { useEffect, useRef, useState } from 'react'
import Breadcrumbs from '../../../assets/component/breadcrumbs'
import { useDispatch, useSelector } from 'react-redux'

import './style.scss'
import { message, Select, Tooltip, Spin, Row, Col, Radio } from 'antd'

import uris from '../../../config/uris'
import { FetchCompaniesAction, FetchCompaniesReset } from '../../../store/slices/ai-chat/fetchCompanies'
import { ControListAction, ControListReset } from '../../../store/slices/contro-research/contro-list'
import dayjs from 'dayjs'
import CustomModal from '../../../assets/component/modal'
import { FaSearch } from 'react-icons/fa'
import CustomTable from '../../../assets/component/table'

const menuData = {
    title: 'Contro Research',
    parentMenu: {
        name: 'Contro Research',
        link: uris?.controResearch,
    },
    subMenu: {
        name: 'Research Assistant',
        link: uris?.controResearch,
    },
}

const rangeSelectOptions = [
    { label: 'Last 1 week', value: 7 },
    { label: 'Last 2 weeks', value: 14 },
    { label: 'Last 1 month', value: 30 },
    { label: 'Last 2 months', value: 60 },
    { label: 'Last 3 months', value: 90 },
    { label: 'Last 4 months', value: 120 },
]

const sortByOptions = [
    { label: 'Negative Sentiment - High to Low', value: 1 },
    { label: 'Negative Sentiment - Low to High', value: -1 },
]

const ControNewsDetailsModal = ({ news }) => {
    return (
        <div className="details-modal-container">
            <div dangerouslySetInnerHTML={{ __html: news || '' }} />
        </div>
    )
}

const NewsCard = ({ news, setModalDetails }) => {
    const handleShowModal = () => {
        setModalDetails({ show: true, content: news })
    }

    const truncatedText = () => {
        const minLength = 200 //Letters in a sentence incl space
        return (
            <div className="text-wrapper">
                <div className="text-content">{`${news?.text?.slice(0, minLength)}${news?.text?.length > 200 ? '...' : ''}`}</div>
                <div className="show-option" onClick={() => handleShowModal()}>
                    Show more
                </div>
            </div>
        )
    }

    let sentiment_code =
        news?.sentiment < -0.75 && news?.sentiment > -1 ? 'severe' : news?.sentiment < -0.5 && news?.sentiment > -0.75 ? 'worse' : news?.sentiment < -0.25 && news?.sentiment > -0.5 ? 'bad' : 'decent'

    return (
        <div className="controversy-card-wrapper">
            <div className="card-details-section">
                <div className="details-content">
                    <div className="details-content-title">{news?.title}</div>
                </div>
                <div className="details-content">
                    <div className="details-content-company-name">{news?.entityName}</div>
                    <div className="details-content-date">{dayjs(news?.articleDate)?.format('DD-MMM-YY')}</div>
                    <div className="details-content-source">{news?.siteName}</div>
                    <div className={`details-content-sentiment ${sentiment_code}`}>{news?.sentiment}</div>
                </div>
            </div>
            <div className="card-description-section">{truncatedText()}</div>
            {news?.categories?.length && (
                <div className="card-category-section">
                    {news.categories.slice(0, 3).map((cat, index) => (
                        <span key={index} className="category-item">
                            {cat?.name}
                        </span>
                    ))}
                </div>
            )}
        </div>
    )
}

const ControListMain = () => {
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [selectedCompanyName, setSelectedCompanyName] = useState([])
    const [selectedPeriod, setSelectedPeriod] = useState(7)
    const [sortBy, setSortBy] = useState(1)
    const [searchBy, setSearchBy] = useState('')
    const [totalCount, setTotalCount] = useState(0)
    const [resetFilterFlag, setResetFilterFlag] = useState(false)
    const [searchType, setSearchType] = useState('like')
    const [formattedTableData, setFormattedTableData] = useState({
        columns: [
            {
                title: 'Articles',
                dataIndex: 'entityName',
                key: 'entityName',
                width: '100%',
            },
        ],
    })
    const [companiesOptions, setCompaniesOptions] = useState([]);
    const [searchCompany, setSearchCompany] = useState('');

    const [modalDetails, setModalDetails] = useState({ show: false, content: null })

    const dispatch = useDispatch()
    const debounceTimeout = useRef(null);
    const { entities: companiesList } = useSelector((state) => state?.fetchCompanies?.data) || {}
    const { data: countyNameData, isLoading: companyLoading } = useSelector((state) => state.fetchCompanies)
    const { data: controversyData, isLoading: controLoading, error: controError } = useSelector((state) => state.controList)

    const getControArticles = () => {
        dispatch(ControListReset())

        const payload = {
            entityId: selectedCompanyName ? selectedCompanyName : [],
            dateRange: Number(selectedPeriod),
            limit: limit,
            page: page,
            sortBy: 'sentiment',
            sortOrder: sortBy || 1,
            searchQuery: searchBy,
            searchType,
        }

        dispatch(ControListAction(payload))
    }

    const handleSearch = (value) => {
        setSearchBy(value.target.value)
    }

    const handleCompanySearch = (value) => {
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        if (value?.length > 2) {
             debounceTimeout.current = setTimeout(() => {
                setSearchCompany(value);
             }, 500);
        }
    }

    const handleCompanyNameChange = (value) => {
        if (selectedCompanyName?.length < 10 || value?.length <= 10) setSelectedCompanyName(value)
        else message.warning('Maximum 10 entities can be selected at a time')
    }

    const handlePeriodChange = (value) => {
        setSelectedPeriod(value)
    }

    const onChangeSearchType = (e) => {
        setSearchType(e.target.value)
    }

    const handleSortChange = (value) => {
        setSortBy(value)
    }

    const handleApplyFilters = () => {
        if (!selectedPeriod) {
            message.error('Please select a period')
            return
        }

        getControArticles()
    }

    const handleResetFilters = () => {
        setSearchBy('')
        setSortBy(1)
        setSelectedCompanyName(null)
        setSelectedPeriod(7)
        setCompaniesOptions([])
        setSearchCompany('')

        setResetFilterFlag(true)
    }

    const handleCloseModal = () => {
        setModalDetails({ show: false, content: null })
    }

    const handleKeyPress = (e) => {
        if (e?.key !== 'Enter' || e?.shiftKey) return

        e?.preventDefault()
        const inputValue = e?.target?.value?.trim()

        if (inputValue) {
            getControArticles()
        }
    }

    useEffect(() => {
        dispatch(FetchCompaniesReset())
        const payload = {
            companyName: [],
            country: [],
            searchBy: 'Public',
            searchType: 'Company',
            searchKeyword: searchCompany || "",
        }

        dispatch(FetchCompaniesAction(payload))
    }, [searchCompany])

    useEffect(() => {
        getControArticles()
    }, [page, limit])

    useEffect(() => {
        if (resetFilterFlag) {
            dispatch(ControListReset())
            setResetFilterFlag(false)
        }
    }, [resetFilterFlag])

    useEffect(() => {
        if (companiesList?.length > 0) {
            setCompaniesOptions(companiesList);
        } else {
            setCompaniesOptions([]);
        }
    }, [companiesList])

    useEffect(() => {
        if (controError?.message) {
            message?.error(controError?.message)
            dispatch(ControListReset())
        }
    }, [controError?.message])

    useEffect(() => {
        if (controversyData?.data?.length) {
            let tableSource = controversyData?.data?.map((news, index) => {
                return { key: index, entityName: <NewsCard news={news} setModalDetails={setModalDetails} /> }
            })
            setFormattedTableData({
                ...formattedTableData,
                dataSource: tableSource,
            })
            setTotalCount(controversyData?.totalCount || 0)
        } else
            setFormattedTableData({
                ...formattedTableData,
                dataSource: [],
            })
    }, [controversyData])

    return (
        <div className="contro-list-main">
            <Breadcrumbs breadcrumbDetails={menuData} />

            <div className="contro-list-filters-section">
                {/* Company Name (optional) */}
                <div className="input-wrapper">
                    <div className="input-label">
                        Company Name
                    </div>
                    <div className="input-container">
                        <Select
                            showSearch
                            allowClear
                            mode="multiple"
                            className="filter-select"
                            options={controversyData?.modified_entity_master || companiesOptions || []}
                            onChange={handleCompanyNameChange}
                            onSearch={handleCompanySearch}
                            value={selectedCompanyName}
                            placeholder="Select Company"
                            maxTagCount="responsive"
                            filterOption={(input, option) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                            notFoundContent={(companyLoading || controLoading) ? <div className="dropdown-loading"><Spin size="small" /></div> : "No Data"}
                        />
                    </div>
                </div>

                {/* Period (mandatory) */}
                <div className="input-wrapper">
                    <div className="input-label">
                        Period <span>*</span>
                    </div>
                    <div className="input-container">
                        <Select className="filter-select" options={rangeSelectOptions} onChange={handlePeriodChange} value={selectedPeriod} placeholder="Select Period" />
                    </div>
                </div>
                {/* Sort By */}
                <div className="input-wrapper">
                    <div className="input-label">
                        Sort By<span>*</span>
                    </div>
                    <div className="input-container">
                        <Select className="filter-select" options={sortByOptions} onChange={handleSortChange} value={sortBy} placeholder="Sort By" />
                    </div>
                </div>
                <div className="input-wrapper search-input-wrapper">
                    <div className="input-label">Keyword Search</div>
                    <div className="input-container">
                        <div className="search-wrapper">
                            <input type="text" className="search-input" placeholder="Search Keyword" value={searchBy} onChange={(e) => handleSearch(e)} onKeyDown={(e) => handleKeyPress(e)} />
                            <FaSearch className={`search-icon ${searchBy ? 'active-icon' : ''}`} onClick={() => getControArticles()} />
                        </div>
                    </div>
                </div>
                <div className="input-wrapper">
                    <div className="input-label">Keyword Search Type</div>
                    <div className="input-container">
                        <Radio.Group className="radio-group" defaultValue="like" onChange={onChangeSearchType} value={searchType}>
                            <Radio value="like">Like</Radio>
                            <Radio value="exact">Exact</Radio>
                            {/* <Radio value="ai">AI Search</Radio> */}
                        </Radio.Group>
                    </div>
                </div>
                {/* Search */}
                <div className="filter-buttons-container">
                    <button type="button" className="filter-button apply-button" onClick={handleApplyFilters}>
                        Apply
                    </button>
                    <button type="button" className="filter-button reset-button" onClick={handleResetFilters}>
                        Reset
                    </button>
                </div>
            </div>

            <CustomTable page={page} limit={limit} setPage={setPage} setLimit={setLimit} tableData={formattedTableData} totalRows={totalCount} isLoading={controLoading} />

            {modalDetails?.show && (
                <CustomModal showCloseIcon handleClose={handleCloseModal} modalTitle={modalDetails?.content?.title || 'Something went wrong!'}>
                    <ControNewsDetailsModal news={modalDetails?.content?.html} />
                </CustomModal>
            )}
        </div>
    )
}

export default ControListMain
